// Toggles `.is-scrollable` and `.is-at-end` on the cue host based on the
// scroll state of an inner horizontal scroller. The CSS uses these classes
// to fade the right-edge chevron in/out.
(function () {
  'use strict';

  const PAIRS = [
    { host: '.header__category-bar', scroller: '.category-nav__container' },
    { host: '.vb-subcategories', scroller: '.vb-subcategories__scroll' },
  ];
  const END_THRESHOLD = 4;

  function update(host, scroller) {
    const canScroll = scroller.scrollWidth - scroller.clientWidth > 1;
    const atEnd =
      scroller.scrollLeft + scroller.clientWidth >= scroller.scrollWidth - END_THRESHOLD;
    host.classList.toggle('is-scrollable', canScroll);
    host.classList.toggle('is-at-end', canScroll && atEnd);
  }

  function bind(host, scroller) {
    if (!host || !scroller) return;
    const handler = () => update(host, scroller);
    scroller.addEventListener('scroll', handler, { passive: true });
    window.addEventListener('resize', handler);
    if ('ResizeObserver' in window) {
      new ResizeObserver(handler).observe(scroller);
    }
    handler();
  }

  function init() {
    for (const { host, scroller } of PAIRS) {
      bind(document.querySelector(host), document.querySelector(scroller));
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
